import { useCallback, useState } from 'react';

const useFormParams = (defaultParams) => {
  const [params, setParams] = useState(defaultParams);

  const onChange = useCallback((name, value) => {
    setParams((p) => ({
      ...p,
      [name]: value,
    }));
  }, []);
  return { params, onChange, setParams };
};

export default useFormParams;
